// extracted by mini-css-extract-plugin
export default {"tooltip":"dU-z","arrow":"eU-z"};